(function() {
    var originalXHR = window.XMLHttpRequest;
    let excludeUrls = ['/event/offer',
        '/catalog/search/api/signal',
        '/us/en/catalog/service/typeahead/suggestion',
        '/global-ui/client-log',
        '/global-ui/force-majeure/',
        '/global-ui/content/navigation/',
        'granite/csrf/token.json',
        '/shop/validatezipcode',
        'etc.clientlibs',
        '/store1/users/service/get-switch-accounts-template',
        '/event/offer/load',
        '/catalog/search/api/signal',
        '/catalog/search/eurules'
    ];

    function isSameOrigin(url) {
        try {
            var parsedUrl = new URL(url, window.location.origin);
            return parsedUrl.origin === window.location.origin;
        } catch (e) {
            window.fisherAnalytics.utils.log("issue with isSameOrigin() in xhr-override " + e);
            return false;
        }
    }


    function isExcluded(url) {
        return excludeUrls.some(function(exclude) {
            return url.indexOf(exclude) !== -1;
        });
    }

    // Create a new constructor that wraps the original XMLHttpRequest
    function newXHR() {
        var xhr = new originalXHR();

        // Override the open method to capture the URL
        var originalOpen = xhr.open;
        xhr.open = function(method, url) {
            this._url = url; // Store the URL for later use
            originalOpen.apply(this, arguments);
        };

        // Override the send method to listen for the response
        var originalSend = xhr.send;
        xhr.send = function(body) {
            this._body = body; // Store the request body for later use
            this._currentPattern = null; // Reset current pattern

            this.addEventListener('readystatechange', function() {
                if (this.readyState === 4) {
                    if (isSameOrigin(this._url) && !isExcluded(this._url)) {
                        processAnalyticsRequest(this._url, this._body, this);
                    }
                }
            });
            try{
                // Call the original send method
                originalSend.apply(this, arguments);
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with newXHR() in xhr-override " + e);
                console.error('Error in XHR override send:', e);
            }
        };

        return xhr;
    }
    // Replace the native XMLHttpRequest with our new constructor
    window.XMLHttpRequest = newXHR;

    // Shared analytics processing function for XHR and fetch
    //TODO see if we can limit the requestBody to just the relevant info instead of the whole payload
    function processAnalyticsRequest(url, requestBody, responseObj) {
        var functions = [];
        var matchedPattern = null;
        var config = null;
        // Match URL against urlPatterns
        var urlMatches = window.fisherAnalytics.urlPatterns.some(function(pattern) {
            if (url.indexOf(pattern) !== -1) {
                matchedPattern = pattern;
                return true;
            }
            return false;
        });
        if (urlMatches) {
            config = window.fisherAnalytics.urlConfig[matchedPattern];
            if (Array.isArray(config.method)) {
                config.method.forEach(function(method) {
                    var fn = window.fisherAnalytics.utils.resolveFunctionPath(method);
                    if (typeof fn === 'function') {
                        functions.push(fn);
                    }
                });
            }
            functions.forEach(function(func) {
                if (typeof func === 'function' && config) {
                    func(requestBody, responseObj, config);
                }
            });
            if (config && config.pauseExecution) {
                setTimeout(() => {}, config.pauseExecution);
            }
        }
    }

    // --- FETCH OVERRIDE START ---
    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');
        var requestBody = init && init.body ? init.body : undefined;
        // Log fetch request
        return originalFetch.apply(this, arguments).then(function(response) {
            var responseClone = response.clone();
            var status = response.status;
            return responseClone.text().then(function(responseText) {
                var mockResponse = {
                    responseText: responseText,
                    status: status
                };
                if (isSameOrigin(url) && !isExcluded(url)) {
                    processAnalyticsRequest(url, requestBody, mockResponse);
                }
                return response;
            }, function(e) {
                window.fisherAnalytics.utils.log('Error reading fetch response text: ' + e);
                var mockResponse = {
                    responseText: '',
                    status: status
                };
                if (isSameOrigin(url) && !isExcluded(url)) {
                    processAnalyticsRequest(url, requestBody, mockResponse);
                }
                return response;
            });
        });
    };
    // --- FETCH OVERRIDE END ---
})();